import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Constants } from '@shared/utils/constants';
import { getWindow } from '@shared/services/window';
import { DataMap } from '@shared/utils/dataMapping';
import { bitMasksContainSomeBitMask, getShortCutBitmask } from '@shared/utils/datamappingHelpers';
import { logger } from '@src/logger';
import { isAzureApp, isTransactApp } from '@shared/utils/appUtils';
export var OwnerType = /*#__PURE__*/ function(OwnerType) {
    OwnerType[OwnerType["App"] = 0] = "App";
    OwnerType[OwnerType["Service"] = 1] = "Service";
    return OwnerType;
}({});
// temp method to hide badge certificates.
export function hideCertificateBadges() {
    return false;
}
export function getDetailInformation(item, id) {
    if (item.detailInformation && item.detailInformation[`${id}`]) {
        return item.detailInformation[`${id}`];
    } else {
        return '';
    }
}
// Use this method only for the Array items in the details fields
export function getDetailArrayItem(item, id) {
    if (item.detailInformation && item.detailInformation[`${id}`] && item.detailInformation[`${id}`].length > 0) {
        return item.detailInformation[`${id}`];
    } else {
        return '';
    }
}
export function getDetailInformationAsDivElement(item, id) {
    const information = this.getDetailInformation(item, id);
    if (information) {
        return /*#__PURE__*/ _jsx("div", {
            children: information
        });
    } else {
        return null;
    }
}
export function getListElements(list, maxItems = -1) {
    const listRender = [];
    if (list) {
        for(let i = 0; i < list.length; i++){
            if (i === maxItems) {
                break;
            }
            listRender.push(/*#__PURE__*/ _jsx("div", {
                className: "leftSideItem",
                children: list[`${i}`]
            }));
        }
    }
    return listRender;
}
export function generateClickPayloadAndLogTelemetry(ownerType, ownerId, actionModifier, detailsObject) {
    const payload = {
        page: getWindow().location.href,
        action: Constants.Telemetry.Action.Click,
        actionModifier,
        details: JSON.stringify(detailsObject)
    };
    if (ownerType === 0) {
        payload.appName = ownerId;
    }
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier
    });
}
export function generateLinkPayloadAndLogTelemetry(ownerType, ownerId, linkType, link, tabOwner) {
    const detailsObject = {
        linkType,
        link,
        tab: tabOwner || ''
    };
    generateClickPayloadAndLogTelemetry(ownerType, ownerId, Constants.Telemetry.ActionModifier.Link, detailsObject);
}
export function generateFilterClickPayloadAndLogTelemetry(ownerType, ownerId, actionModifier, detailsObject) {
    const payload = {
        page: getWindow().location.href,
        action: Constants.Telemetry.Action.FilterClick,
        actionModifier,
        details: JSON.stringify(detailsObject)
    };
    if (ownerType === 0) {
        payload.appName = ownerId;
    }
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier
    });
}
export function generateTileClickPayloadAndLogTelemetry(actionModifier, detailsObject) {
    const payload = {
        page: getWindow().location.href,
        action: Constants.Telemetry.Action.Click,
        actionModifier,
        details: JSON.stringify(detailsObject),
        appName: detailsObject.appName
    };
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier,
        appName: payload.appName
    });
}
export function generateBreadcrumbPayloadAndLogTelemetry(linkType) {
    const detailsObject = {
        linkType,
        link: getWindow().location.href
    };
    const payload = {
        page: getWindow().location.href,
        action: Constants.Telemetry.Action.Click,
        actionModifier: Constants.Telemetry.ActionModifier.Breadcrumb,
        details: JSON.stringify(detailsObject)
    };
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier
    });
}
// Each version of appDetails.tsx (SMP/AMP/Mobile) seem to have a copy of this method
// They should try and use this common method. It could be marked export at that point
function getDetailHyperlinkElement(ownerId, information, id, locString, parentLocString) {
    if (!information) {
        return null;
    } else {
        return /*#__PURE__*/ _jsx("a", {
            className: "c-hyperlink",
            rel: "noreferrer",
            target: "_blank",
            href: information,
            onClick: ()=>{
                generateLinkPayloadAndLogTelemetry(0, ownerId, id, information, 'Default');
            },
            "aria-label": `${parentLocString} ${locString}`,
            children: locString
        });
    }
}
/**
 * Gets the elements of the Support section
 * on the App Details page for AMP/Mobile
 * @export
 * @param {*} item (this.props.App passed down from any of the appDetails.tsx)
 * @param {*} context (this.context passed down from any of the appDetails.tsx)
 * @returns Div containing Support link and/or Help Link if available
 */ export function getSupportElements(item, context) {
    // Both SupportLink and HelpLink are optional and could be null
    // If both are null, don't show 'Support' section. Otherwise, do
    if (!getDetailInformation(item, 'SupportLink') && !getDetailInformation(item, 'HelpLink')) {
        return null;
    } else {
        return /*#__PURE__*/ _jsxs("div", {
            className: "cell",
            children: [
                /*#__PURE__*/ _jsx("header", {
                    children: context.loc('App_Support')
                }),
                getDetailHyperlinkElement(item.entityId, getDetailInformation(item, 'SupportLink'), 'SupportLink', context.loc('App_Support'), context.loc('App_Support')),
                getDetailHyperlinkElement(item.entityId, getDetailInformation(item, 'HelpLink'), 'HelpLink', context.loc('App_Help'), context.loc('App_Support'))
            ]
        });
    }
}
export function addSaaSBundleProperties(payloadDetails, app) {
    if (payloadDetails && app.linkedAddIns && app.linkedAddIns.length > 0) {
        payloadDetails.isSaaSBundle = true;
    }
    return payloadDetails;
}
export function getProductsList(products) {
    const filterDatamapBlocks = DataMap[`${Constants.filterMaps.products}`];
    const filteritems = [];
    Object.keys(filterDatamapBlocks).map((value)=>{
        const currentDatamapBlock = filterDatamapBlocks[`${value}`];
        if (products && !currentDatamapBlock.ShortcutFilters && bitMasksContainSomeBitMask(getShortCutBitmask(currentDatamapBlock), products)) {
            const filter = currentDatamapBlock;
            if (!filter) {
                return null;
            }
            filteritems.push({
                title: filter.Title,
                urlKey: filter.UrlKey
            });
        }
        return null;
    });
    return filteritems;
}
export const shouldShowUserTerms = ({ app, billingCountryCode })=>{
    const { ctaTypes } = app;
    const CtaRequiringTerms = [
        Constants.CTAType.Contact,
        Constants.CTAType.RequestTrial
    ];
    return !isAzureApp(app) && !isTransactApp({
        isEmbedded: false,
        ctaTypes,
        appData: app,
        billingRegion: billingCountryCode
    }) && !CtaRequiringTerms.includes(ctaTypes[0]);
};
